/* eslint-disable react-hooks/exhaustive-deps */
import classes from './veryNewProposalDesign.module.scss';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ReactStars from 'react-stars'
import React, { useEffect, useState } from 'react';
import { ItineraryAccommodation, SortedItem } from '../../atom/Types';


interface props {
    ind: number
    day: number
    singleAccomodationNode: SortedItem
    key: string
    selectedAccomodationID: string
    setAccomodationModal: React.Dispatch<React.SetStateAction<boolean>>
    setActiveAccomodation: React.Dispatch<React.SetStateAction<ItineraryAccommodation | undefined>>
}

const SingleAccomodationCard: React.FC<props> = ({ ind, day, singleAccomodationNode, selectedAccomodationID, setAccomodationModal, setActiveAccomodation }) => {



    const [displayPrice, setDisplayPrice] = useState<number>()
    const [index, setIndex] = useState<number>(0)

    function isPackageAccommodation(item: SortedItem): item is ItineraryAccommodation {
        return item.type === 'accommodation'
    }


    const handleError = (media: string) => {
        if (index !== media.length - 1) {
            setIndex(index + 1)
        }

    }

    useEffect(() => {
        let price = 0;

        if (isPackageAccommodation(singleAccomodationNode)) {
            price = singleAccomodationNode.packagePrice > 0 ? singleAccomodationNode.packagePrice > 0 ? singleAccomodationNode.packagePrice :
                singleAccomodationNode.packagePrice > 0 ? singleAccomodationNode.packagePrice :
                    singleAccomodationNode.packagePrice :
                singleAccomodationNode.packagePrice > 0 ? singleAccomodationNode.packagePrice :
                    singleAccomodationNode.benchmarkPrice > 0 ? singleAccomodationNode.benchmarkPrice :
                        singleAccomodationNode.seaparatePrice > 0 ? singleAccomodationNode.seaparatePrice :
                            singleAccomodationNode.publishedPrice > 0 ? singleAccomodationNode.publishedPrice :
                                singleAccomodationNode.netPrice > 0 ? singleAccomodationNode.netPrice : 0;
        } else if (isPackageAccommodation(singleAccomodationNode)) {
            const selectedRooms = singleAccomodationNode.roomDetails.filter(room => room.selected);
            if (selectedRooms.length === 0) {
                const prices = singleAccomodationNode.roomDetails.map(room => room.price).filter(price => price !== null) as number[];
                price = prices.length > 0 ? Math.min(...prices) : 0;
            } else {
                price = selectedRooms.reduce((total, room) => total + (room.price ?? 0), 0);
            }
        }

        setDisplayPrice(price);
    }, ['roomDetails' in singleAccomodationNode && singleAccomodationNode?.roomDetails?.filter(node => node.selected).length]);



    const handleAccomodationDetials = (data: ItineraryAccommodation, index: number) => {


        data.index = index
        data.day = day
        data.ind = ind
        data.days = calculateDays(data?.checkInDate, data?.checkOutDate)?.split(" ")
        setActiveAccomodation(data);

        setAccomodationModal(true);

        let flagCount = 0;

        data.roomDetails.length > 0 ? data.roomDetails.map((n) => {
            return n.selected ? flagCount = flagCount + 1 : flagCount
        }) : flagCount = 0

    }

    const calculateDays = (sD: string, eD: string) => {

        const startDate = new Date(sD).getTime()
        const endDate = new Date(eD).getTime()


        if (!isNaN(startDate) && !isNaN(endDate)) {
            const timeDifference = endDate - startDate;
            const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return ` for ${daysDifference} ${daysDifference === 1 ? `day` : `days`}`
        } else {
            return null
        }

    }
    const getMediaURL = () => {
        if (isPackageAccommodation(singleAccomodationNode)) {
            if (singleAccomodationNode?.accommodation?.media[index]?.url != null) {
                return singleAccomodationNode?.accommodation?.media[index]?.url
            } else {
                setIndex(index + 1)
            }
        }
    }
    return (

        <div className={classes.AccomodationCardContainer}
            style={{ border: `${singleAccomodationNode?.id === selectedAccomodationID ? "2px solid #0279CF" : ""}` }} >
            <div className={classes.SingleAccomodationCard}>
                <div className={classes.AccomodationImage}>
                    {isPackageAccommodation(singleAccomodationNode) && singleAccomodationNode?.accommodation?.media?.length > 0 && index !== singleAccomodationNode?.accommodation?.media.length - 1 ?
                        <img src={getMediaURL()} onError={() => handleError(singleAccomodationNode?.accommodation?.media[index]?.url)} width={140} height={100} alt='media' /> :
                        <img src={"https://travelsment-dev.s3.amazonaws.com/media/istockphoto-1147544807-612x612.jpg"} width={140} height={100} alt='travelsment' />}
                </div>
                <div className={classes.AccomodationInfo}>
                    <div className={classes.AccomodationName}>{isPackageAccommodation(singleAccomodationNode) && singleAccomodationNode?.accommodation?.name}</div>
                    {
                        isPackageAccommodation(singleAccomodationNode) && singleAccomodationNode?.accommodation?.rating ?
                            <div className={classes.StarsContainer}>
                                <ReactStars
                                    count={5}
                                    value={singleAccomodationNode?.accommodation?.rating ? +singleAccomodationNode?.accommodation?.rating.replace('R', '').replace('_', '.') : 0}
                                    edit={false}
                                    // onChange={ratingChanged}
                                    size={24}
                                    color1={"#E0E6ED"}
                                    color2={'#FFC700'}

                                />

                            </div> :
                            <div style={{ fontSize: "12px", fontStyle: "italic", color: "lightgray" }}>No rating</div>
                    }


                    <div className={classes.MoreInfoContainer}>

                        {isPackageAccommodation(singleAccomodationNode) && <div className={classes.packagePrice}>$ {displayPrice} {calculateDays !== null && <span className={classes.span}>{calculateDays(singleAccomodationNode?.checkInDate, singleAccomodationNode?.checkOutDate)?.split(" ")[2] === "1" ? "for 1 Night" : `for ${calculateDays(singleAccomodationNode?.checkInDate, singleAccomodationNode?.checkOutDate)?.split(" ")[2]} Nights`}
                        </span>}</div>}
                        {isPackageAccommodation(singleAccomodationNode) && <div className={classes.DetailsTextContainer} onClick={() => { handleAccomodationDetials(singleAccomodationNode, ind) }}>
                            <div>Details</div>
                            <KeyboardArrowRightIcon />
                        </div>}
                    </div>

                </div>

            </div>
            {
                singleAccomodationNode.selected ?
                    <div className={classes.SelectedAccomodationCard}>
                        <CheckCircleRoundedIcon style={{ color: "white", transform: "scale(0.8)" }} />
                        <div className={classes.SelectedText}>Selected</div>
                    </div> : null
            }
        </div>

    )
}

export default SingleAccomodationCard